import { Component, OnInit,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-create-folder',
  templateUrl: './create-folder.page.html',
  styleUrls: ['./create-folder.page.scss'],
})
export class CreateFolderPage implements OnInit {
  //This is the folder that we are currently in
  @Input() current_folder: any = null;
  
  folder_info = {
    guid: '0',
    title: '',
    visible_to_client: true
  }

  constructor(private modalController: ModalController,private apiService: ApiService,private globalService: GlobalService) { }

  ngOnInit() {
    this.folder_info.guid = this.current_folder.guid;
  }
  

  async CreateFolder(){
    let return_data: any = await this.apiService.post('folders',this.folder_info);
    if(return_data.success) {
      this.modalController.dismiss(return_data.data);
    }
    this.globalService.presentToastMessage(return_data.message,return_data.success);

  }
  async Dismiss(){
    this.modalController.dismiss();
  }

}
